import React from 'react';

const ConfirmDeleteModal = ({
  open,
  title = 'Delete Item',
  message,
  onConfirm,
  onCancel,
  confirmText = 'Delete',
  cancelText = 'Cancel'
}) => {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div
        className="modal"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: 420 }}
      >
        <h3 style={{ marginBottom: 12 }}>{title}</h3>

        <p style={{ color: '#555', marginBottom: 24 }}>
          {message}
        </p>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 12
          }}
        >
          <button
            className="cancel-btn"
            onClick={onCancel}
          >
            {cancelText}
          </button>

          <button
            className="delete-btn"
            onClick={onConfirm}
            style={{ background: '#e74c3c', color: '#fff' }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
